import { fontStyles } from '@/styles/typography';

const StyledH1 = ({ children }: { children: React.ReactNode }) => (
  <h1
    className={fontStyles({
      variant: 'H1',
      class: [
        'mb-8',
        'text-[2rem]',
        'leading-[2.5rem]',
        'tablet:text-[4rem]',
        'tablet:leading-[4.25rem]',
      ],
    })}
  >
    {children}
  </h1>
);
const StyledH2 = ({ children }: { children: React.ReactNode }) => (
  <h2 className={fontStyles({ variant: 'H5', class: ['mt-8 mb-4'] })}>{children}</h2>
);
const StyledSubtitle = ({ children }: { children: React.ReactNode }) => (
  <h2 className={fontStyles({ variant: 'LABEL_LG', class: ['mt-0 mb-16'] })}>{children}</h2>
);
const StyledParagraph = ({ children }: { children: React.ReactNode }) => (
  <p className={fontStyles({ variant: 'BODY_LG', class: ['mt-4 mb-12'] })}>{children}</p>
);
const StyledSpan = ({ children }: { children: React.ReactNode }) => (
  <span className="font-medium">{children}</span>
);
const StyledLink = ({ href, children }: { href: string; children: React.ReactNode }) => (
  <a href={href} className="text-[rgb(94_136_243)]">
    {children}
  </a>
);
const StyledUnorderedList = ({ children }: { children: React.ReactNode }) => (
  <ul className={fontStyles({ variant: 'BODY_LG' })}>{children}</ul>
);
const StyledListItem = ({ children }: { children: React.ReactNode }) => (
  <li className="mt-4 mb-6">{children}</li>
);

export {
  StyledH1,
  StyledH2,
  StyledSubtitle,
  StyledParagraph,
  StyledSpan,
  StyledLink,
  StyledUnorderedList,
  StyledListItem,
};
